





























import { version } from "../../../../../package.json";

import windowMixin from "@/utils/windowMixin";

import NavBar from "./NavBar.vue";

export default windowMixin.extend({
  name: "Header",
  components: {
    NavBar,
  },
  data() {
    return { version };
  },
});
